import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FnScreenResolutionComponent } from './fn-screen-resolution.component';
import { FnButtonModule } from '../button/index';

export * from './fn-screen-resolution.component';

@NgModule({
	imports: [CommonModule, FormsModule, FnButtonModule],
	declarations: [FnScreenResolutionComponent],
	exports: [FnScreenResolutionComponent],
})
export class FnScreenResolutionModule {}
